/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：249
 */

module.exports = {
  sliderImageDialog: "styles_sliderImageDialog__3INv5",
  sliderImage: "styles_sliderImage__2cRzu",
  title: "styles_title__1At28",
  sliderPreview: "styles_sliderPreview__2bl7-",
  previewBox: "styles_previewBox__MuMOn",
  backgroundImage: "styles_backgroundImage__yvX-l",
  trackImageBox: "styles_trackImageBox__35jqK",
  trackImage: "styles_trackImage__jMrKs",
  handleImage: "styles_handleImage__Xs2AN",
  vertical: "styles_vertical__1WWOV",
  imageInfo: "styles_imageInfo__k8ETN",
  imageList: "styles_imageList__tBY3b",
  imageItem: "styles_imageItem__2XvQp",
  imageItemBox: "styles_imageItemBox__qcvxy",
  image: "styles_image__1LfVK",
  cover: "styles_cover__3R0A0",
  replaceBtn: "styles_replaceBtn__ftYVF",
  handleSize: "styles_handleSize__oaWfF",
  sizeLabel: "styles_sizeLabel__lXgha",
  imagePopover: "styles_imagePopover__3Ofwf",
  content: "styles_content__3JDUx",
  contentTitle: "styles_contentTitle__QRQv9"
}
